import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import { ExclamationTriangleFill, CheckCircleFill, Eye, EyeSlash  } from 'react-bootstrap-icons';


const ResetPassword = () => {
  const { token } = useParams();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);  // State for password visibility

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      setTimeout(() => {
        setError(''); // Clear the message after 3 seconds
      }, 3000);
      return;
    }

    try {
      const response = await axios.post('http://localhost:5000/admin/reset-password', { token, newPassword });
      setMessage(response.data.message);
      setTimeout(() => {
        navigate('/signin');
      }, 3000);
    } catch (err) {
      setError(err.response ? err.response.data.message : 'Server error');
    }
  };
  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  return (
    <Container fluid className="d-flex align-items-center justify-content-center min-vh-100" style={{
      fontFamily:'Poppins, san-serif'
    }}>
      <Row className="w-100 justify-content-center">
        <Col md={6} lg={4}>
          <div className="reset-password-container p-4 border rounded bg-light">
            <Form onSubmit={handleResetPassword} >
              <h2 className="mb-4 text-center">Reset Password</h2>
              {message && <Alert variant="success"><CheckCircleFill className='mx-1 text-success'/>{message}</Alert>}
              {error && <Alert variant="danger"><ExclamationTriangleFill className='mx-1 text-danger'/>{error}</Alert>}
              <Form.Group controlId="new-password" className="mb-3">
                <Form.Label>New Password:</Form.Label>

                <div className="password-input">
              <Form.Control type={showPassword ? 'text' : 'password'} placeholder="New Password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
              <Button variant="link" onClick={togglePasswordVisibility}>
                {showPassword ? <EyeSlash /> : <Eye />}
              </Button>
            </div>

              </Form.Group>
              <Form.Group controlId="confirm-password" className="mb-3">
                <Form.Label>Confirm Password:</Form.Label>

              <div className="password-input">
              <Form.Control type={showPassword ? 'text' : 'password'} placeholder="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
              <Button variant="link" onClick={togglePasswordVisibility}>
                {showPassword ? <EyeSlash /> : <Eye />}
              </Button>
            </div>

              </Form.Group>
              <Button variant="warning" type="submit" className="w-100">Reset Password</Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword;
